import { render } from "./HistIAIrrig.vue?vue&type=template&id=1944ebe3&scoped=true"
import script from "./HistIAIrrig.vue?vue&type=script&lang=js"
export * from "./HistIAIrrig.vue?vue&type=script&lang=js"

import "./HistIAIrrig.vue?vue&type=style&index=0&id=1944ebe3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1944ebe3"]])

export default __exports__